import { getMykissEnv } from './getMykissEnv';

export function isStaging(): boolean {
  return getMykissEnv() === 'staging';
}
